export interface CapitalQueryPermissions {
  authorityKeys: string[];
  queryDictKeys: string[];
}

function normalizeStringList(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return [];
  }
  const normalized = value
    .map((item: unknown): string => String(item || '').trim())
    .filter((item: string): boolean => Boolean(item));
  return [...new Set<string>(normalized)];
}

export function normalizeCapitalQueryPermissions(value: any): CapitalQueryPermissions {
  const authorityKeys = normalizeStringList(value?.authorityKeys);
  const queryDictKeys = normalizeStringList(value?.queryDictKeys);
  return { authorityKeys, queryDictKeys };
}
